// extracted by css-extract-rspack-plugin
export default {"hidden":"hidden--p_mItx95ChMJlGuF","buttons":"buttons--IEpLUO5WCojIiECS","column":"column--VtYB1XI0kzQDomLe"};